import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useTCStore } from '@lib/store';
import type { AccountEntity, CardsEntity } from '@shared/api';
import CloseIcon from '@assets/icons/messages/close.svg';

interface FooterProps {
  className?: string;
  account: AccountEntity;
  card: CardsEntity;
  onClose: (value: boolean) => void;
}

export const TermsConditionsModal = (props: FooterProps) => {
  const TCStore = useTCStore();

  const { t } = useTranslation();

  useEffect(() => {
    TCStore.get(props.account.product.code);
  }, []);

  return (
    <div className='mt-[10vh] w-full mx-8'>
      <div className='bg-[#e5e3e3] text-[#929293] p-8 relative'>
        <div className='border-b border-b-[#929293] mb-[18px] uppercase'>{t('footer.modals.termsCondition.title')}</div>
        <div className='cursor-pointer absolute right-4 top-4' onClick={() => props.onClose(false)}>
          <CloseIcon />
        </div>
        <div className='flex mt-5'>
          <img className='h-[82px] w-[130px] mr-12 shadow-[0_10px_14px_0_rgba(0,0,0,0.4)]' src={props.account?.mainCard.cardDesignImageUrl} />
          <div className='flex flex-col'>
            <span>{props.card.cardHolder}</span>
            <span>{props.account.product.name}</span>
          </div>
        </div>
      </div>
      <div className='bg-white text-[#76708c] p-8 max-h-[60vh] overflow-y-auto'>
        {TCStore.data && <div dangerouslySetInnerHTML={{ __html: TCStore.data }} className='whitespace-pre-wrap' />}
      </div>
    </div>
  );
};
